import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import SearchController from "./controllers/search_controller"
import ComparisonChartController from "./controllers/comparison_chart_controller"
import MarketFinderController from "./controllers/market_finder_controller"
import SaveSearchController from "./controllers/save_search_controller"
import AlertBuilderController from "./controllers/alert_builder_controller"
import AlertRunnerController from "./controllers/alert_runner_controller"
import AlertResultsController from "./controllers/alert_results_controller"
import SidebarController from "./controllers/sidebar_controller"
import NotificationDrawerController from "./controllers/notification_drawer_controller"
import EducationDrawerController from "./controllers/education_drawer_controller"
import HeatMapController from "./controllers/heat_map_controller"
import ImportMonitorController from "./controllers/import_monitor_controller"
import UploadProgressController from "./controllers/upload_progress_controller"
import RebuildMonitorController from "./controllers/rebuild_monitor_controller"
import CleanupMonitorController from "./controllers/cleanup_monitor_controller"
import DragSortController from "./controllers/drag_sort_controller"
import MultiselectController from "./controllers/multiselect_controller"
import QuickFinderController from "./controllers/quick_finder_controller"
import PortfolioController from "./controllers/portfolio_controller"
import PortfolioFormController from "./controllers/portfolio_form_controller"
import ExploreController from "./controllers/explore_controller"

const application = Application.start()
application.register("search", SearchController)
application.register("comparison-chart", ComparisonChartController)
application.register("market-finder", MarketFinderController)
application.register("save-search", SaveSearchController)
application.register("alert-builder", AlertBuilderController)
application.register("alert-runner", AlertRunnerController)
application.register("alert-results", AlertResultsController)
application.register("sidebar", SidebarController)
application.register("notification-drawer", NotificationDrawerController)
application.register("education-drawer", EducationDrawerController)
application.register("heat-map", HeatMapController)
application.register("import-monitor", ImportMonitorController)
application.register("upload-progress", UploadProgressController)
application.register("rebuild-monitor", RebuildMonitorController)
application.register("cleanup-monitor", CleanupMonitorController)
application.register("drag-sort", DragSortController)
application.register("multiselect", MultiselectController)
application.register("quick-finder", QuickFinderController)
application.register("portfolio", PortfolioController)
application.register("portfolio-form", PortfolioFormController)
application.register("explore", ExploreController)
